(function () {
  'use strict';
  function closeDetails(details, restoreFocus) {
    details.removeAttribute('open');
    if (restoreFocus) { var summary = details.querySelector('summary'); if (summary) summary.focus(); }
  }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-gg-disclosure][open]').forEach(function (details) { closeDetails(details, details.contains(document.activeElement)); });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-gg-disclosure][open]').forEach(function (details) { if (!details.contains(event.target)) closeDetails(details, false); });
  });
  document.addEventListener('toggle', function (event) {
    var target = event.target;
    if (!target.matches || !target.matches('[data-gg-disclosure][open]')) return;
    document.querySelectorAll('[data-gg-disclosure][open]').forEach(function (details) { if (details !== target && !details.contains(target) && !target.contains(details)) closeDetails(details, false); });
  }, true);
}());
(function () {
  'use strict';
  function updateDealWindows() {
    document.querySelectorAll('[data-gg-deal-window]').forEach(function (element) {
      var start = Date.parse(element.dataset.start);
      var end = Date.parse(element.dataset.end);
      var now = Date.now();
      element.hidden = !Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end;
    });
  }
  updateDealWindows();
  window.setInterval(updateDealWindows, 1000);
  document.addEventListener('visibilitychange', updateDealWindows);
  document.addEventListener('shopify:section:load', updateDealWindows);
}());
(function () {
  'use strict';
  var tokenPattern = /(?:https?:\/\/|www\.)[^\s<>]+|[\w.+-]+@[\w.-]+\.[a-z]{2,}|\bgoodgram\.[a-z]{2,}(?:\/[^\s<>]*)?|\bgoodgram\b(?:®)?/gi;
  function registerBrandText(value) {
    return value.replace(tokenPattern, function (token) { return /^goodgram$/i.test(token) ? token + '®' : token; });
  }
  var excluded = 'script,style,noscript,textarea,input,select,option,code,pre,svg,math,[contenteditable],.gg-wordmark,[data-gg-no-trademark]';
  function updateText(node) {
    if (!node.parentElement || node.parentElement.closest(excluded) || !/goodgram/i.test(node.data)) return;
    var next = node.nextSibling;
    if (next && next.nodeType === 1 && next.tagName === 'SUP' && next.textContent.trim() === '®') return;
    var text = registerBrandText(node.data);
    if (text !== node.data) node.data = text;
  }
  function updateRoot(root) {
    if (root.nodeType === 3) { updateText(root); return; }
    if (root.nodeType !== 1 || root.closest(excluded)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) updateText(node);
  }
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'characterData') updateText(record.target);
      else record.addedNodes.forEach(updateRoot);
    });
  });
  document.querySelectorAll('.gg-header,#MainContent,.gg-footer').forEach(function (root) {
    updateRoot(root);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  });
  document.addEventListener('shopify:section:load', function (event) {
    updateRoot(event.target);
    observer.observe(event.target, { childList: true, subtree: true, characterData: true });
  });
}());
(function () {
  'use strict';
  function setHidden(root, selector, hidden) { root.querySelectorAll(selector).forEach(function (element) { element.hidden = hidden; }); }
  function updateFlashSales() {
    var now = Date.now();
    document.querySelectorAll('[data-gg-flash-end]').forEach(function (root) {
      var end = Number(root.dataset.ggFlashEnd) * 1000;
      var start = Number(root.dataset.ggFlashStart) * 1000;
      var active = Number.isFinite(start) && Number.isFinite(end) && start <= now && now < end;
      if (!active) {
        if (root.hasAttribute('data-gg-flash-card')) {
          setHidden(root, '[data-gg-flash-sale-price], .gg-flash-card-badge, .gg-flash-card-note', true);
          setHidden(root, '[data-gg-flash-regular-price]', false);
        } else if (root.hasAttribute('data-gg-flash-section')) {
          setHidden(root, '[data-gg-flash-active]', true);
          setHidden(root, '[data-gg-flash-ended]', false);
        } else { root.hidden = true; }
        return;
      }
      var remaining = Math.max(0, Math.ceil((end - now) / 1000));
      var values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      root.querySelectorAll('[data-gg-flash-countdown]').forEach(function (timer) {
        Object.keys(values).forEach(function (unit) {
          var field = timer.querySelector('[data-flash-' + unit + ']');
          var value = String(values[unit]).padStart(2, '0');
          if (field && field.textContent !== value) field.textContent = value;
        });
        var clock = timer.querySelector('.gg-flash-clock');
        if (clock) clock.hidden = false;
        var deadline = timer.querySelector('[data-gg-flash-deadline]');
        if (deadline && !deadline.dataset.localized) {
          deadline.textContent = new Intl.DateTimeFormat(undefined, {month:'short', day:'numeric', year:'numeric', hour:'numeric', minute:'2-digit', timeZone:'America/New_York', timeZoneName:'short'}).format(new Date(end));
          deadline.dataset.localized = 'true';
        }
      });
    });
  }
  updateFlashSales();
  window.setInterval(updateFlashSales, 1000);
  document.addEventListener('visibilitychange', updateFlashSales);
  document.addEventListener('shopify:section:load', updateFlashSales);
}());
(function () {
  'use strict';
  var inFlight = false;
  var lastCheck = 0;
  async function refreshExpiredDailySale() {
    if (document.hidden || inFlight || Date.now() - lastCheck < 30000) return;
    var root = document.querySelector('[data-gg-daily-section]');
    if (!root) return;
    var oldEnd = Number(root.dataset.ggFlashEnd) * 1000;
    if (!Number.isFinite(oldEnd) || oldEnd > Date.now()) return;
    var sectionId = root.dataset.ggDailySection;
    if (!sectionId) return;
    inFlight = true;
    lastCheck = Date.now();
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      url.searchParams.set('_gg_daily', String(Date.now()));
      var response = await fetch(url.toString(), {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(12000)});
      if (!response.ok) return;
      var data = await response.json();
      if (!data[sectionId]) return;
      var doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
      var replacement = doc.querySelector('[data-gg-daily-section]');
      if (!replacement) return;
      var newEnd = Number(replacement.dataset.ggFlashEnd) * 1000;
      var newStart = Number(replacement.dataset.ggFlashStart) * 1000;
      var oldIds = Array.from(root.querySelectorAll('[data-gg-daily-product]')).map(function(x){return x.dataset.ggDailyProduct;});
      var newIds = Array.from(replacement.querySelectorAll('[data-gg-daily-product]')).map(function(x){return x.dataset.ggDailyProduct;});
      if (newEnd <= Date.now() || newStart > Date.now() || newEnd <= oldEnd || newIds.length !== 5) return;
      if (oldIds.length && newIds.some(function(id){return oldIds.includes(id);})) return;
      if (!replacement.querySelector('[data-gg-flash-active]')) return;
      root.replaceWith(replacement);
    } catch (error) {
      return;
    } finally {
      inFlight = false;
    }
  }
  window.setInterval(refreshExpiredDailySale, 30000);
  document.addEventListener('visibilitychange', refreshExpiredDailySale);
}());
